import { Injectable } from '@angular/core';

import { AuthService } from '../../../../core';

/** Service que valida os acessos e execuções de funcionalidades das revisões das Análises de Mercado */
@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode exibir as revisões */
    canShowRevisoes(idsRepresentante: number[]): boolean {
        // Exibe as revisão somente quando possuir apenas um representante filtrado ou for um representante
        return (idsRepresentante != null && idsRepresentante.length === 1) || this.authService.isRepresentante();
    }

    /** Verifica se pode exibir as informações das revisões */
    canShowInfos(): boolean {
        return true;
    }

    /** Verifica se pode abrir uma nova revisão */
    canAbrir(revisao: {isSemRevisao: boolean}): boolean {
        if (!revisao) {
            return false;
        }

        return revisao.isSemRevisao;
    }

    /** Verifica se pode reabrir a revisão */
    canReabrir(revisao: {isAprovada: boolean}): boolean {
        if (!revisao) {
            return false;
        }
        // Se não estiver aprovada
        if (!revisao.isAprovada) {
            return false;
        }
        // Somente se o usuário possuir permissão de gerenciar as revisões
        return this.authService.podeGerenciarRevisoesAnalisesMercado();
    }

    /** Verifica se pode revisar */
    canRevisar(revisao: {isAberta: boolean}, revisaoMode: boolean): boolean {
        if (!revisao) {
            return false;
        }
        // Somente se estiver aberta e não estiver em modo de revisão
        return revisao.isAberta && !revisaoMode;
    }

    /** Verifica se pode confirmar as alterações da revisão */
    canConfirmar(revisao: {isAberta: boolean}, revisaoMode: boolean): boolean {
        if (!revisao) {
            return false;
        }
        // Somente se estiver aberta e estiver em modo de revisão
        return revisao.isAberta && revisaoMode;
    }

    /** Verifica se pode aprovar a revisão */
    canAprovar(revisao: {isAberta: boolean}): boolean {
        if (!revisao) {
            return false;
        }
        // Se não estiver aberta
        if (!revisao.isAberta) {
            return false;
        }
        // Somente se o usuário possuir permissão de gerenciar as revisões
        return this.authService.podeGerenciarRevisoesAnalisesMercado();
    }
}

